import { Box, Tab, Tabs } from "@mui/material";
import { PageContainer } from "../../components/container/PageContainer";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { Breadcrumb } from "../../layout/fullLayout/breadcrumb/Breadcrumb";
import { IBreadcrumbProps } from "../../layout/fullLayout/breadcrumb/IBreadcrumbProps";
import { FolderOpen, GridView } from "@mui/icons-material";
import { StandadCard } from "../../components/Cards";
import { TabPanel, TabContext } from "@mui/lab";
import { ComplaintPartner } from "./ComplaintPartner";
import { Complaint } from "./Complaint";
import React from "react";

const BCrumb: IBreadcrumbProps["items"] = [
    {
        to: "/",
        title: "ccl-main",
    },
    {
        title: "ccl-complaint",
    },
];

export const ComplaintTab: React.FC = () => {
    const auth = useAuth();
    const role = auth.user.role;

    // Manage tab state
    const [tabValue, setTabValue] = React.useState("0");

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
    };

    return (
        <PageContainer title="" description="this is innerpage">
            <Breadcrumb title="Complaints" items={BCrumb} />
            <TabContext value={tabValue}>
                <Box sx={{ borderBottom: 1, marginBottom: 3, borderColor: "divider" }}>
                    <Tabs value={tabValue} onChange={handleTabChange}>
                        <Tab
                            icon={<GridView />}
                            iconPosition="start"
                            label="Crossroads"
                            value="0"
                        />
                        <Tab
                            sx={{ minHeight: "50px" }}
                            icon={<FolderOpen />}
                            iconPosition="start"
                            label="B2B"
                            value="1"
                        />
                    </Tabs>
                </Box>
                {/* <StandadCard> */}
                <Box>
                    <TabPanel value="0">
                        <Complaint />
                    </TabPanel>
                    <TabPanel value="1">
                        <ComplaintPartner />
                    </TabPanel>
                </Box>
                {/* </StandadCard> */}
            </TabContext>
        </PageContainer>
    );
};
